import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { useTabBar } from "@website/ui/tab-bar/tab-bar.hook";
import styles from "@website/ui/tab-bar/tab-bar.module.scss";
import { TabBarPropertiesType } from "@website/ui/tab-bar/tab-bar.types";
import { TabButton } from "@website/ui/tab-button";
import { FC } from "react";
export const TabBar: FC<TabBarPropertiesType> = properties => {
  const $ = _c(30);
  const {
    "aria-label": ariaLabel,
    className,
    color: t0,
    variant: t1,
    iconPosition: t2,
    orientation: t3,
    behavior: t4,
    size: t5,
    tabs,
    value
  } = properties;
  const color = t0 === undefined ? "primary" : t0;
  const variant = t1 === undefined ? "contained" : t1;
  const iconPosition = t2 === undefined ? "top" : t2;
  const orientation = t3 === undefined ? "horizontal" : t3;
  const behavior = t4 === undefined ? "button" : t4;
  const size = t5 === undefined ? "content" : t5;
  const {
    buttonsContainerProps,
    nextScrollProps,
    previousScrollProps
  } = useTabBar(properties);
  const t6 = `${styles["tab-bar"]} ${styles[orientation]} ${styles[color]} ${styles[variant]} ${className ?? ""}`;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <MaterialIcon className={styles["nav-button-icon"]} name="arrow_back_ios" variant="outlined" />;
    $[0] = t7;
  } else {
    t7 = $[0];
  }
  let t8;
  if ($[1] !== previousScrollProps) {
    t8 = <div {...previousScrollProps} className={styles["nav-button"]}>{t7}</div>;
    $[1] = previousScrollProps;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  let t9;
  if ($[3] !== behavior || $[4] !== color || $[5] !== iconPosition || $[6] !== size || $[7] !== tabs || $[8] !== value || $[9] !== variant) {
    let t10;
    if ($[11] !== behavior || $[12] !== color || $[13] !== iconPosition || $[14] !== size || $[15] !== value || $[16] !== variant) {
      t10 = (item, index) => <TabButton Icon={item.Icon} Wrapper={item.Wrapper} badge={item.badge} behavior={behavior} color={color} description={item.description} disabled={item.disabled} href={item.href} iconPosition={iconPosition} index={index} key={item.title} onClick={item.onClick} selected={value === index} size={size} title={item.title} variant={variant} />;
      $[11] = behavior;
      $[12] = color;
      $[13] = iconPosition;
      $[14] = size;
      $[15] = value;
      $[16] = variant;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    t9 = tabs.map(t10);
    $[3] = behavior;
    $[4] = color;
    $[5] = iconPosition;
    $[6] = size;
    $[7] = tabs;
    $[8] = value;
    $[9] = variant;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[18] !== ariaLabel || $[19] !== buttonsContainerProps || $[20] !== t9) {
    t10 = <div {...buttonsContainerProps} aria-label={ariaLabel} className={styles["buttons-container"]} role="tablist">{t9}</div>;
    $[18] = ariaLabel;
    $[19] = buttonsContainerProps;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <MaterialIcon className={styles["nav-button-icon"]} name="arrow_forward_ios" variant="outlined" />;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== nextScrollProps) {
    t12 = <div {...nextScrollProps} className={styles["nav-button"]}>{t11}</div>;
    $[23] = nextScrollProps;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12 || $[27] !== t6 || $[28] !== t8) {
    t13 = <div className={t6}>{t8}{t10}{t12}</div>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t6;
    $[28] = t8;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};